module.exports = __webpack_public_path__ + "static/media/Icons_refresh.963c7bf1.svg";